window.urthDeliveryNowIST = () =>
  new Date(new Date().toLocaleString('en-US', { timeZone: 'Asia/Kolkata' }));

window.urthDeliverySlotClosed = (date, time) => {
  const now = window.urthDeliveryNowIST();
  const today = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
  if (date && date < today) return true;
  if (date === '2026-10-20') return true; // Store closed
  if (date === '2026-11-01') return true; // Store closed
  if (date === '2026-10-02' && ['4:30 PM - 7:30 PM', '7:30 PM - 9:30 PM'].includes(time)) return true;
  const cutoffHours = {
    '10:30 AM - 1:30 PM': 9,
    '1:30 PM - 4:30 PM': 12,
    '4:30 PM - 7:30 PM': 15,
    '7:30 PM - 9:30 PM': 17,
  };
  return date === today && time in cutoffHours && now.getHours() >= cutoffHours[time];
};

(() => {
  const message = document.querySelector('script[data-closed-message]').dataset.closedMessage;
  const approvedForms = new WeakSet();
  const pendingForms = new WeakSet();

  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!['cart', 'CartDrawer-Form'].includes(form.id) || event.submitter?.name !== 'checkout') return;
    if (approvedForms.delete(form)) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    if (pendingForms.has(form)) return;
    pendingForms.add(form);
    const button = event.submitter;

    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart.js`, { cache: 'no-store' });
      if (!response.ok) throw new Error('Unable to check delivery slot');
      const cart = await response.json();
      if (window.urthDeliverySlotClosed(cart.attributes?.['Delivery Date'], cart.attributes?.['Delivery Time'])) {
        window.alert(message);
        return;
      }
      approvedForms.add(form);
      form.requestSubmit(button);
      approvedForms.delete(form);
    } catch (error) {
      console.error(error);
      window.alert(message);
    } finally {
      pendingForms.delete(form);
    }
  }, true);
})();
